import { useEffect, useState } from "react";
import LoadingScreen from "@/components/LoadingScreen";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import VisionMission from "@/components/sections/VisionMission";
import Journey from "@/components/sections/Journey";
import Legacy from "@/components/sections/Legacy";
import RoyaleRaas from "@/components/sections/RoyaleRaas";
import Upcoming from "@/components/sections/Upcoming";
import Gallery from "@/components/sections/Gallery";
import CareerHero from "@/components/sections/careers/CareerHero";
import ContactUs from "@/components/sections/ContactUs";
import Footer from "@/components/sections/Footer";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2400);
    return () => clearTimeout(t);
  }, []);

  // Land on the section a cross-page navbar link asked for (e.g. arriving
  // from /careers via "/#contact") instead of stopping at the top. Waits for
  // the page layout to stop changing height (e.g. the Gallery grid's images
  // loading in) before scrolling, since Contact sits below Gallery and an
  // early jump would land short of it while those images are still loading.
  useEffect(() => {
    if (!window.location.hash) return;
    const el = document.getElementById(window.location.hash.slice(1));
    if (!el) return;

    let stopped = false;
    let settleTimer = null;

    const stop = () => {
      if (stopped) return;
      stopped = true;
      clearTimeout(settleTimer);
      clearTimeout(maxWaitTimer);
      ro.disconnect();
    };

    // Re-scroll on every layout change (images loading in below shift the
    // target down), and finish once the layout has been quiet for a beat.
    const onResize = () => {
      if (stopped) return;
      el.scrollIntoView({ behavior: "auto", block: "start" });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(stop, 200);
    };

    const ro = new ResizeObserver(onResize);
    ro.observe(document.body);
    onResize();

    // Safety net so a perpetually-resizing page can't block this forever.
    const maxWaitTimer = setTimeout(() => {
      el.scrollIntoView({ behavior: "auto", block: "start" });
      stop();
    }, 6000);

    return stop;
  }, []);

  // Fade-up on scroll
  useEffect(() => {
    if (loading) return;
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loading]);

  return (
    <>
      {loading && <LoadingScreen />}
      <div
        data-testid="home-root"
        style={{ visibility: loading ? "hidden" : "visible" }}
      >
        <Navbar />
        <main>
          <Hero />
          <About />
          <VisionMission />
          <Journey />
          <Legacy />
          <RoyaleRaas />
          <Upcoming />
          <Gallery />
          <CareerHero />
          <ContactUs />
        </main>
        <Footer />
      </div>
    </>
  );
}
